import { render, staticRenderFns } from "./CartConflictModal.vue?vue&type=template&id=1dcda63e&"
import script from "./CartConflictModal.vue?vue&type=script&lang=js&"
export * from "./CartConflictModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports